import { render, staticRenderFns } from "./ModalItem.vue?vue&type=template&id=79958ab6&scoped=true&"
import script from "./ModalItem.vue?vue&type=script&lang=js&"
export * from "./ModalItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalItem.vue?vue&type=style&index=0&id=79958ab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79958ab6",
  null
  
)

export default component.exports